export abstract class ValidationService {
  showError: (data: any) => string[];
}
